export enum WidgetsEnum {
	medicine = 'medicine',
	pulse = 'pulse',
	diagnosis = 'diagnosis'
}
